var exports = {
  "Ze": "AddFriendView.module__friendRequestContainer___Wll1ek",
  "Nr": "AddFriendView.module__card___Wll1ek",
  "Og": "AddFriendView.module__heroIcon___Wll1ek",
  "DD": "AddFriendView.module__title___Wll1ek",
  "VA": "AddFriendView.module__subtitle___Wll1ek",
  "KJ": "AddFriendView.module__formContainer___Wll1ek",
};

module.exports = exports;
